import React from 'react';
import { bonusComparison } from '../../data/howItWorks';
export function BonusComparison() {
  return <div data-id="element-271" data-mp="25yjq5xpg2trh">
      <p className="mb-2 text-xs font-semibold text-sf-weak" data-id="element-272" data-mp="25ytc9a7dcgrw">Same rule, three outcomes</p>
      <ul className="grid grid-cols-1 gap-2 md:grid-cols-3" data-id="element-273" data-mp="2jxt1aiysmxol">
        {bonusComparison.map(item => <li key={item.name} className={`flex flex-col rounded border px-3 py-2 ${item.applied ? 'border-[#B0CDF5] bg-sf-blue-light' : 'border-sf-border bg-white'}`} data-id="element-274" data-mp="2exesuzta5lq1">
            <p className="text-[13px] font-semibold" data-id="element-275" data-mp="2owvw7al27niu">
              {item.name} <span className="font-normal text-sf-weak" data-id="element-276" data-mp="2oujk3e1zg7dp">· {item.branch} · {item.units} closed loans</span>
            </p>
            <p className={`mt-1 text-lg font-bold tabular-nums ${item.applied ? 'text-sf-blue-dark' : 'text-sf-weak'}`} data-id="element-277" data-mp="2xoxtizzu0now">{item.result}</p>
            <p className="text-xs text-sf-weak" data-id="element-278" data-mp="3cn9rd9yxy2hn">{item.reason}</p>
            <p className="mt-auto pt-1 font-mono text-[11px] text-sf-text" data-id="element-279" data-mp="37ndo5cy2if35">{item.ruleKey}</p>
          </li>)}
      </ul>
    </div>;
}